module.exports = __webpack_public_path__ + "e01dd4e4899528105001dbef64e380ee.svg";